// extracted by mini-css-extract-plugin
export default {"with-svg-core-badge":"AqBV-","withSvgCoreBadge":"AqBV-"};